// TokenService.js - Create this file in a services folder
import { jwtDecode } from 'jwt-decode';

const TokenService = {
  // Check if token exists
  hasToken: () => {
    return !!localStorage.getItem('token');
  },

  // Check if token exists and is valid
  isValidToken: () => {
    const hasToken = TokenService.hasToken();
    if (!hasToken) return false;
    
    const isExpired = TokenService.isTokenExpired();
    const isInactive = TokenService.isInactive();
    
    if (isExpired || isInactive) {
      TokenService.removeToken();
      return false;
    }
    
    return true;
  },

  // Get token
  getToken: () => {
    return localStorage.getItem('token');
  },

  // Store token with expiry timestamp
  setToken: (token) => {
    try {
      const decodedToken = jwtDecode(token);
      const expiryTime = decodedToken.exp * 1000; // Convert to milliseconds
      
      localStorage.setItem('token', token);
      localStorage.setItem('tokenExpiry', expiryTime);
      
      // Record last activity time
      TokenService.updateActivity();
      
      return true;
    } catch (error) {
      console.error('Invalid token format:', error);
      return false;
    }
  },

  // Remove token
  removeToken: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('tokenExpiry');
    localStorage.removeItem('lastActivity');
  },

  // Check if token is expired
  isTokenExpired: () => {
    try {
      const expiryTime = localStorage.getItem('tokenExpiry');
      return expiryTime && new Date().getTime() > parseInt(expiryTime);
    } catch (error) {
      return true; // Assume expired if error
    }
  },

  // Update last activity timestamp
  updateActivity: () => {
    localStorage.setItem('lastActivity', new Date().getTime().toString());
  },

  // Check if session is inactive
  isInactive: (inactivityLimit = 30 * 60 * 1000) => { // Default 30 minutes
    const lastActivity = localStorage.getItem('lastActivity');
    if (!lastActivity) return true;
    
    const inactiveTime = new Date().getTime() - parseInt(lastActivity);
    return inactiveTime > inactivityLimit;
  },

  // Get user role from token
  getUserRole: () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return null;
      
      const decoded = jwtDecode(token);
      return decoded.role;
    } catch (error) {
      console.error('Error extracting role:', error);
      return null;
    }
  },

  // Get username from token
  getUsername: () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return null;
      
      const decoded = jwtDecode(token);
      return decoded.name;
    } catch (error) {
      console.error('Error extracting username:', error);
      return null;
    }
  },

  getId: () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return null;
      
      const decoded = jwtDecode(token);
      return decoded.idUser;
    } catch (error) {
      console.error('Error extracting username:', error);
      return null;
    }
  }
};

export default TokenService;